import { IconProps } from "./";
import Icon from "./assets/award_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Award(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
